import React, { FC } from "react";
import { Form, Input, Select, Button, Row, Col, Collapse } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateField } from "../../../../models/preAuthClaimSlice";
import { errorMessage } from "../../../../utils/notificationUtils";
import { RootState } from "../../../../store/store";
import { Spin } from "antd";

interface EchsProcedureFormProps {
  form: any;
  procedureDropDown: any[];
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
  portalSubmission: boolean;
  handleDeleteProcedure?: (procedure: any) => boolean;
  totalClaimedAmount: number;
  totalEchsRate: number;
  onAmountChange?: any;
}

const { Panel } = Collapse;

const EchsProcedureForm: FC<EchsProcedureFormProps> = ({
  form,
  procedureDropDown,
  isEditable,
  caseClaimSubmissionId,
  portalSubmission,
  handleDeleteProcedure,
  totalClaimedAmount,
  totalEchsRate,
  onAmountChange,
}) => {
  const dispatch = useDispatch();
  const { auth, preAuthClaim } = useSelector((state: RootState) => state);

  return (
    <Collapse
      defaultActiveKey={["1"]}
      bordered={false}
      style={{
        border: "1px solid lightgray",
        borderRadius: "20px",
        marginBottom: "0.8rem",
        background: "#F2F6F9",
        padding: "2px 10px",
      }}
    >
      <Panel
        header={
          <h4 style={{ margin: 0 }}>Treatment / Radiology / Investigation</h4>
        }
        key="1"
        style={{ borderRadius: "20px" }}
      >
        {preAuthClaim?.isFetchingProcedure ? (
          <div
            style={{
              margin: "auto",
              width: "100%,",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Form.List name="items">
            {(fields, { add, remove }) => (
              <>
                <div
                  style={{
                    maxHeight: "50vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    padding: "20px",
                    marginBottom: "1rem",
                  }}
                >
                  {fields.map((field, index) => (
                    <Row
                      key={field.key}
                      gutter={[16, 0]}
                      align="top"
                      style={{
                        border: "1px solid black",
                        padding: "10px 20px",
                        borderRadius: "16px",
                        marginBottom: "0.6rem",
                      }}
                    >
                      <Col span={8}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Procedure Service Name"
                          name={[field.name, "procedureServiceName"]}
                          // rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input disabled={true} style={{ color: "black" }} />
                        </Form.Item>
                      </Col>

                      <Col span={8}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Procedure"
                          name={[field.name, "procedureID"]}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Select
                            showSearch
                            placeholder="Select a Procedure"
                            options={procedureDropDown?.map((option: any) => {
                              const {
                                hospitalAmount,
                                hospitalRate,
                                hospitalRemark,
                                expenseUnit,
                                normalRate,
                                admissibleRate,
                                ...rest
                              } = option;
                              return {
                                value: JSON.stringify(rest),
                                label: rest.expenseName,
                                expenseUnit,
                                admissibleRate,
                              };
                            })}
                            onChange={(value, option) => {
                              const parsedValue = JSON.parse(value);
                              const hospitalRate = (option as any).admissibleRate;
                              const enteredExpenseUnit = (option as any).expenseUnit;

                              if (hospitalRate && enteredExpenseUnit) {
                                const hospitalAmount =
                                  parseFloat(hospitalRate) *
                                  parseFloat(enteredExpenseUnit);
                                form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      hospitalAmount:
                                        hospitalAmount?.toString(),
                                    },
                                  },
                                });
                                dispatch(
                                  updateField({
                                    sectionKey: "echsClaimSubmissionResponse",
                                    fieldId: "items",
                                    value: form.getFieldsValue(["items"])
                                      ?.items,
                                  }),
                                );
                              }
                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    expenseCode: parsedValue.expenseCode,
                                    expenseUnit: (option as any).expenseUnit,
                                    // admissibleRate: parsedValue.admissibleRate,
                                    admissibleRate: (option as any)
                                      .admissibleRate,
                                    hospitalRate: (option as any).admissibleRate
                                  },
                                },
                              });
                            }}
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={7}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Procedure Code"
                          name={[field.name, "expenseCode"]}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter Procedure Code"
                            onChange={(e) => {
                              const enteredExpenseCode = e.target.value.trim();
                              const matchedProcedure = procedureDropDown?.find(
                                (item: any) =>
                                  item.expenseCode === enteredExpenseCode,
                              );

                              if (matchedProcedure) {
                                const procedureValue = JSON.stringify({
                                  rateType: matchedProcedure.rateType,
                                  expenseType: matchedProcedure.expenseType,
                                  expenseCode: matchedProcedure.expenseCode,
                                  procedureID: matchedProcedure.procedureID,
                                  expenseName: matchedProcedure.expenseName,
                                  // normalRate: matchedProcedure.normalRate,
                                  // admissibleRate: matchedProcedure.admissibleRate,
                                });

                                form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      procedureID: procedureValue,
                                      expenseUnit:
                                        matchedProcedure?.expenseUnit,
                                      admissibleRate:
                                        matchedProcedure?.admissibleRate,
                                    },
                                  },
                                });
                                dispatch(
                                  updateField({
                                    sectionKey: "echsClaimSubmissionResponse",
                                    fieldId: "items",
                                    value: form.getFieldsValue(["items"])
                                      ?.items,
                                  }),
                                );
                              }
                            }}
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={1}>
                        {fields.length > 0 &&
                          !(!isEditable && !!caseClaimSubmissionId) &&
                          !portalSubmission && (
                            <Button
                              type="text"
                              style={{ color: "red", padding: "0" }}
                              icon={<MinusCircleOutlined />}
                              onClick={() => {
                                const procedure = form.getFieldValue([
                                  "items",
                                  index,
                                ]);
                                if (procedure?.id) {
                                  const res =
                                    handleDeleteProcedure?.(procedure);
                                  if (res) {
                                    remove(field.name);
                                  }
                                } else {
                                  remove(field.name);
                                }
                              }}
                            />
                          )}
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="QUANTITY/NO OF DAYS"
                          name={[field.name, "expenseUnit"]}
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: /^\d+$/,
                              message: "Only numeric values are allowed!",
                            },
                          ]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter QUANTITY/NO OF DAYS"
                            onChange={(e) => {
                              onAmountChange?.();
                              const enteredExpenseUnit = e.target.value.trim();
                              const hospitalRate = form.getFieldValue([
                                "items",
                                index,
                                "hospitalRate",
                              ]);

                              if (hospitalRate && enteredExpenseUnit) {
                                const hospitalAmount =
                                  parseFloat(hospitalRate) *
                                  parseFloat(enteredExpenseUnit);
                                form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      hospitalAmount:
                                        hospitalAmount?.toString(),
                                    },
                                  },
                                });
                                dispatch(
                                  updateField({
                                    sectionKey: "echsClaimSubmissionResponse",
                                    fieldId: "items",
                                    value: form.getFieldsValue(["items"])
                                      ?.items,
                                  }),
                                );
                              }
                            }}
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="ECHS RATE"
                          name={[field.name, "admissibleRate"]}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter ECHS RATE"
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Hospital Rate"
                          name={[field.name, "hospitalRate"]}
                          rules={[
                            { required: true, message: "Required" },
                            // {
                            //   pattern: /^\d+$/,
                            //   message: "Numeric values are allow!",
                            // },
                            {
                              pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                              message:
                                "Only numeric values with up to 2 decimal places are allowed!",
                            },
                            {
                              validator: async (_, value) => {
                                const admissibleRate = form.getFieldValue([
                                  "items",
                                  index,
                                  "admissibleRate",
                                ]);
                                if (
                                  value &&
                                  parseFloat(value) > parseFloat(admissibleRate)
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      `Hospital Rate must be lesser than or equal to ${admissibleRate}`,
                                    ),
                                  );
                                }
                              },
                            },
                          ]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter Hospital Rate"
                            onChange={(e) => {
                              onAmountChange?.();
                              const enteredHospitalRate = e.target.value.trim();
                              const admissibleRate = form.getFieldValue([
                                "items",
                                index,
                                "admissibleRate",
                              ]);
                              const expenseUnit = form.getFieldValue([
                                "items",
                                index,
                                "expenseUnit",
                              ]);

                              if (
                                parseFloat(enteredHospitalRate) >
                                parseFloat(admissibleRate)
                              ) {
                                errorMessage(
                                  `Hospital Rate must be lesser than or equal to ${admissibleRate}`,
                                );
                              } else if (expenseUnit && enteredHospitalRate) {
                                const hospitalAmount =
                                  parseFloat(expenseUnit) *
                                  parseFloat(enteredHospitalRate);
                                form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      hospitalAmount:
                                        hospitalAmount?.toString(),
                                    },
                                  },
                                });
                                dispatch(
                                  updateField({
                                    sectionKey: "echsClaimSubmissionResponse",
                                    fieldId: "items",
                                    value: form.getFieldsValue(["items"])
                                      ?.items,
                                  }),
                                );
                              }
                            }}
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Remarks"
                          name={[field.name, "hospitalRemark"]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter Remarks"
                            onChange={() =>
                              form.getFieldsValue(["items"])
                                ? dispatch(
                                    updateField({
                                      sectionKey: "echsClaimSubmissionResponse",
                                      fieldId: "items",
                                      value: form.getFieldsValue(["items"])
                                        ?.items,
                                    }),
                                  )
                                : null
                            }
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <div style={{ width: "100%" }}>
                        <h4 style={{ display: "flex", justifyContent: "end" }}>
                          Hospital Amount: ₹{" "}
                          {form.getFieldValue([
                            "items",
                            index,
                            "hospitalAmount",
                          ]) ?? 0}
                          /-
                        </h4>
                      </div>
                    </Row>
                  ))}
                </div>

                {!portalSubmission && (
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    style={{
                      color: "white",
                      background: "rgb(0, 76, 143)",
                      border: "1px solid #C4C4C4",
                      boxShadow: "0px 2px 8px 0px #00000040",
                    }}
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  >
                    Add Procedure
                  </Button>
                )}

                <div
                  style={{
                    width: "100%",
                    marginBottom: "0.1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <h4
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2rem",
                    }}
                  >
                    Total Procedure Echs Rate: ₹ {totalEchsRate || 0}/-
                  </h4>

                  <h4 style={{ display: "flex", justifyContent: "end" }}>
                    Total Procedure Amount: ₹ {totalClaimedAmount || 0}/-
                  </h4>
                </div>
              </>
            )}
          </Form.List>
        )}
      </Panel>
    </Collapse>
  );
};

export default EchsProcedureForm;
